import loadable from '@loadable/component';

export const ConnectPage = loadable(() =>
  import('./ConnectPage').then(module => module.ConnectPage),
);
